module.exports = __webpack_public_path__ + "img/footer.35d066d9.svg";